export default "__VITE_ASSET__b27b811c__"